import { render, staticRenderFns } from "./WebhooksView.vue?vue&type=template&id=39c6caa2&"
import script from "./WebhooksView.vue?vue&type=script&lang=ts&"
export * from "./WebhooksView.vue?vue&type=script&lang=ts&"
import style0 from "./WebhooksView.vue?vue&type=style&index=0&id=39c6caa2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WebhooksView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports